import { Component,Input, OnDestroy, OnInit } from '@angular/core';
import { RequestResult } from '@app/core/dto/RequestResult';
import { SessionStorageService } from '@app/core/services/session-storage.service';
import { vwGroupPerformance } from '@app/kip/dto/vwPerformance';
import { PerformanceService } from '@app/kip/services/performance-service';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';

@AutoUnsubscribe()
@Component({
  selector: 'performance-widget',
  templateUrl: './performance-widget.component.html',
  styleUrls: ['./performance-widget.component.scss']
})
export class PerformanceWidgetComponent  implements OnInit,OnDestroy{

  @Input() TaskType : string;

  loaded:boolean = false;
  loadPerformaceData$ : Subscription;
  groupPerformanceData  : vwGroupPerformance;
  
  constructor(
     public sessionStorageService : SessionStorageService,
     public performanceService : PerformanceService
  ) { }



  ngOnInit(): void {
    this.loadPerformaceData$ = this.performanceService.LoadGroupPerformances(this.sessionStorageService.getSelectedUnit(), 
                              this.sessionStorageService.getSelectedHotelId(), this.TaskType).subscribe((result) => {
                                const res = result as RequestResult
                              this.groupPerformanceData = res.Data as vwGroupPerformance
                              this.loaded = true;
                              
    });
  }
  ngOnDestroy(): void {
    this.loadPerformaceData$?.unsubscribe();
  }


  roundedNumber( perf : number) {
    return Math.round(perf)
  }
}
